import React from 'react';
import { BaseLayout } from './BaseLayout';
import { layoutConfigs } from './layoutConfigs';
import { InvestorSidebar } from './InvestorSidebar';

interface InvestorLayoutProps {
  children: React.ReactNode;
}

export const InvestorLayout: React.FC<InvestorLayoutProps> = ({ children }) => {
  return (
    <BaseLayout
      sidebar={<InvestorSidebar />}
      config={layoutConfigs.investor}
    >
      {children}
    </BaseLayout>
  );
};
